import React from 'react';

import Modal from 'components/curo-components/common/Modal';
import ModalButtonsWrapper from 'components/curo-components/common/ModalButtonsWrapper';
import Button from 'components/digifi-wrappers/Button';
import { DocumentIcon } from 'static/images';


interface IQualifyModalProps {
  onClose: () => void;
  onConfirm: () => void;
}

const QualifyModal = ({ onClose, onConfirm }: IQualifyModalProps) => {
  return (
    <Modal
      title="Thank you for starting your application."
      description="We couldn't find an existing offer, but you are welcome to continue with an application. Please continue the process below."
      onClose={onClose}
      modalIcon={<DocumentIcon />}
      actionElement={
        <ModalButtonsWrapper>
          <Button kind="primary" size="form" onClick={onConfirm}>
            Continue
          </Button>
        </ModalButtonsWrapper>
      }
    />
  );
};

export default QualifyModal;
